import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDotsIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 24,
	viewBox: "0 0 32 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 10.5,
			cy: 12.5,
			r: 1.5,
			fill: "#B4BFCB"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 15.5,
			cy: 12.5,
			r: 1.5,
			fill: "#B4BFCB"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 20.5,
			cy: 12.5,
			r: 1.5,
			fill: "#B4BFCB"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: .5,
			y: .5,
			width: 31,
			height: 23,
			rx: 4.5,
			stroke: "#B4BFCB",
			strokeOpacity: .45
		})
	]
});
export default SvgDotsIcon;
